Space1.Notifications = {
    $list: null,
    $dropdown: null,
    $btn: null,
    $viewAllBtn: null,
    $unreadCount: null,
    $innerCount: null,
    isOpen: false,
    notifications: [],
    notificationModel: {
        type: null,
        text: null,
        id: null,
        status: null,
        progress: null,
        state: null,
        linktype: null
    },
    eNotificationTypes: {
        generic: 0,
        alert: 1,
        progress: 2
    },
    eNotificationState: {
        queue: 0,
        inProgress: 1,
        completed: 2,
        error: 3
    },
    eNotificationStatus: {
        read: 0,
        notRead: 1
    },
    eLinkType:
    {
        Download: 0,
        Url: 1
    },
    setUnreadCount(count) {
        this.$unreadCount.text(count);
        this.$innerCount.text(Space1.Strings.getKey('YouHave{}Notifications').replace('{}', count));
        if (count == 0) {
            this.$unreadCount.css('opacity', 0);
        } else {
            this.$unreadCount.css('opacity', 100);
        }
    },
    setNotifications(notifications) { // array of notificationModel
        this.$list.empty();

        notifications.forEach(notification => {
            this.addNotification(notification);
        });
    },
    addNotification(notification) {
        if (notification) {
            if ($("#" + notification.id.toSafeID()).length == 0) {
                const $notification = $('<li>', {
                    id: notification.id.toSafeID(),
                    class: `notification notification--${Object.keys(this.eNotificationStatus)[notification.status]} notification--${Object.keys(this.eNotificationTypes)[notification.type]} notification--${Object.keys(this.eNotificationState)[notification.state]}`
                });
                const $notificationProgressBar = $('<div class="notification__progressbar"></div>').hide();

                $notification.append(`<i class="notification__icon ${this.getNotificationIcon(notification)}"></i>`)

                $notification.append(`<span class="notification__text">${notification.text}</span>`);
                $notification.append($notificationProgressBar);

                $notification.click(() => {
                    this.doNotificationAction(notification);
                });

                this.$list.append($notification);

                if (notification.type == this.eNotificationTypes.progress && (notification.state == this.eNotificationState.inProgress || notification.state == this.eNotificationState.queue && notification.state != this.eNotificationState.error)) {
                    this.attachProgress(notification);
                }

                this.notifications.push(notification);
                this.setUnreadCount(this.notifications.length);
            }
        }
    },
    attachProgress(notification) {
        const $notificationProgressBar = $(`#${notification.id.toSafeID()} .notification__progressbar`);
        if (notification.state.error) {
            $notificationProgressBar.hide();
        } else {
            $notificationProgressBar.show();
            const loadAnimation = $notificationProgressBar[0]["loadAnimation"] !== undefined ? $notificationProgressBar[0]["loadAnimation"] : new LoadAnimation(`#${notification.id.toSafeID()} .notification__progressbar`, "progressbar");
            loadAnimation.setProgress(notification.progress, `${notification.progress}%`);
        }

        if (notification.progress == 100) {
            $notificationProgressBar.hide();
        }
    },
    updateNotification(notification) {
        if (notification) {
            const $notification = this.$list.find("#" + notification.id.toSafeID());
            $notification.find(".notification__text").text(notification.Description);

            Object.keys(this.eNotificationState).forEach(k => {
                $notification.removeClass(`notification--${k}`);
            });
            $notification.addClass(`notification--${Object.keys(this.eNotificationState)[notification.state]}`);

            $notification.off('click');
            $notification.click(() => {
                this.doNotificationAction(notification);
            });

            if (notification.type == this.eNotificationTypes.queue || notification.type == this.eNotificationTypes.progress) {
                this.attachProgress(notification);
            }
        }
    },
    getNotificationIcon(notification) {
        switch (notification.type) {
            case this.eNotificationTypes.alert:
                return 'fas fa-exclamation-triangle';
            case this.eNotificationTypes.progress:
                if (notification.state == this.eLinkType.error) {
                    return "fas fa-times";
                }
                if (notification.linktype != null) {
                    if (notification.linktype == this.eLinkType.Download) {
                        return 'fas fa-download';
                    } else if (notification.linktype == this.eLinkType.Url) {
                        return 'glyphicon glyphicon-arrow-right';
                    }
                }
            default:
                return 'far fa-circle';
        }
    },
    doNotificationAction(notification) {
        if (notification.type != this.eNotificationTypes.progress || notification.state == this.eNotificationState.completed) {
            var unreadcount = parseInt(this.$unreadCount.text());
            if (unreadcount >= 1) {
                this.setUnreadCount(unreadcount - 1);
            } else {
                this.setUnreadCount(0);
            }
            $("#" + notification.id.toSafeID()).hide();

            this.connection.invoke("ReadNotification", notification.id);
            let modalContentUrl = '';

            let modal = null;
            switch (notification.type) {
                case this.eNotificationTypes.progress:
                    if (notification.state == this.eNotificationState.completed || notification.state == this.eNotificationState.error) {
                        $.ajax({
                            url: `${Space1.Env.getBaseUrl()}/Notification/ShowNotification?notificationId=${notification.id}`,
                            success: function (redirect) {
                                $("body").append(redirect);
                            }
                        });
                    }
                    break;
                default:
                    modalContentUrl = `${Space1.Env.getBaseUrl()}/Notification/ShowNotification?notificationId=${notification.id}`;
                    modal = new Space1.UI.Modal({
                        remote: modalContentUrl,
                        backdrop: 'static',
                        size: 'large',
                        defaultActions: false,
                        autodestruction: true,
                        autodestructionWait: 0,
                        footer: true,
                    });

                    modal.dom.$modal.on('loaded.bs.modal', () => {

                    });

                    modal.open();
                    break;
            }
        }
    },
    onOpen() {

    },
    onViewAll() {

    },
    initSignalr() {
        let self = this;
        var connection = new signalR.HubConnectionBuilder()
            .withUrl("/notificationsHub")
            .build();

        const newNotificaiton = function (notification) {
            const resultObj = JSON.parse(notification);
            console.log(resultObj);
            let n = {
                type: resultObj.Type,
                text: resultObj.Description,
                id: '' + resultObj.NotificationId,
                status: self.eNotificationStatus.notRead,
                progress: resultObj.ProgressPercentage,
                state: resultObj.State,
                linktype: resultObj.LinkType
            };
            self.addNotification(n);
        }

        const updateNotificaitonManagement = function (notification) {
            const resultObj = JSON.parse(notification);
            console.log(resultObj);
            let n = {
                type: resultObj.Type,
                text: resultObj.Description,
                id: '' + resultObj.NotificationId,
                status: self.eNotificationStatus.notRead,
                progress: resultObj.ProgressPercentage,
                state: resultObj.State,
                linktype: resultObj.LinkType
            };
            self.updateNotification(n);
        }

        const unreadNotifications = function (result) {
            const resultObj = JSON.parse(result);
            console.log(resultObj);
            self.setUnreadCount(resultObj.UnreadNotificationsCount);
            resultObj.Notifications.forEach(notification => {
                self.addNotification({
                    type: notification.Type,
                    text: notification.Description,
                    id: '' + notification.NotificationId,
                    status: self.eNotificationStatus.notRead,
                    progress: notification.ProgressPercentage,
                    state: notification.State,
                    linktype: notification.LinkType
                });
            });
        }

        connection.on("UnreadNotificationsResult", unreadNotifications);
        connection.on("NewNotification", newNotificaiton);
        connection.on("UpdateNotification", updateNotificaitonManagement);

        connection.start().then(function () {
            console.log("Started hub")
            connection.invoke("UnreadNotifications");
        }).catch(function (err) {
            return console.error(err.toString());
        });
        return connection;
    },
    init() {
        this.$dropdown = $('#notifications-dropdown');
        this.$list = $('#notifications-list');
        this.$btn = $('#notifications-button');
        this.$viewAllBtn = $('#notification-view-all');
        this.$unreadCount = $('#notifications-unread-count');
        this.$innerCount = $('#notifications-inner-count');

        this.$btn.click(() => {
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
                this.onOpen();
            }
        });

        this.$viewAllBtn.click(() => {
            this.onViewAll();
        });

        this.connection = this.initSignalr();
        // here we should get the unread notifications count
    },
};
